<template>
    <div>
        <v-dialog
            name="reconfirm_session"
            width="500"
            :clickToClose="false"
        />
    </div>
</template>

<script>
export default {
    props: [
        'initialEndDate',
    ],

    data() {
        return {
            autoLogoutTimeout: null,
            autoLogoutTimeInSeconds: 60 * 5,
            dialogShown: false,
            endDate: null,
            secondsLeft: '',
            sessionCountDownInterval: null,
        }
    },

    computed: {
        autoLogoutTimeInMilliseconds() {
            return this.autoLogoutTimeInSeconds * 1000;
        },

        endTime() {
            return moment.utc(this.endDate).format('x');
        },
    },

    mounted() {
        this.endDate = this.initialEndDate;
        this.startSessionCountDown();
    },

    beforeDestroy() {
        this.resetSessionCountDown();
    },

    methods: {
        startSessionCountDown() {
            this.sessionCountDownInterval = setInterval(() => {
                let distance = this.endTime - moment.utc().format('x');
                this.secondsLeft = distance / 1000;

                if ((! this.dialogShown ) && (this.secondsLeft < this.autoLogoutTimeInSeconds)) {
                    this.dialogShown = true;
                    this.show();
                    this.startAutoLogoutCountDown();
                }
            }, 1000);
        },

        startAutoLogoutCountDown() {
            this.autoLogoutTimeout = setTimeout(() => {
                this.hide();
            }, this.autoLogoutTimeInMilliseconds);
        },

        resetSessionCountDown() {
            clearInterval(this.sessionCountDownInterval);
            clearTimeout(this.autoLogoutTimeout);
            this.sessionCountDownInterval = null;
            this.autoLogoutTimeout = null;
            this.dialogShown = false;
        },

        updateSessionEndTime() {
            this.resetSessionCountDown();
            this.$modal.hide('dialog');

            axios
                .get('/update-session-end-time')
                .then(res => {
                    this.endDate = res.data.end_date;
                    this.startSessionCountDown();
                })
                .catch(error => console.log('error updating end date', error));
        },

        hide() {
            this.resetSessionCountDown();
            this.$modal.hide('dialog');
            
            axios
                .get('/logout')
                .then(() => location.href = '/')
                .catch(error => console.log('error logging out ', error));
        },

        show() {
            this.$modal.show('dialog', {
                title: 'Your Session is About to Expire',
                text: 'You have less than 5 minutes before your session expires. Would you like to stay logged in?',
                buttons: [
                    {
                        title: 'No, sign me out.',
                        class: 'vue-dialog-button cancel',
                        handler: () => { 
                            this.hide();
                        },
                    },
                    {
                        default: true,
                        title: 'Yes, keep me signed in.',
                        class: 'vue-dialog-button confirm',
                        handler: () => { 
                            this.updateSessionEndTime();
                        },
                    },
                ],
            });
        },
    },
}
</script>

<style>
.v--modal-overlay[name="reconfirm_session"] {
    background-color: rgba(0,0,0,0.5);
}

.v--modal-overlay[name="reconfirm_session"] .vue-dialog .dialog-content {
    font-size: 16px;
    padding: 20px;
}

.vue-dialog-button.cancel,
.vue-dialog-button.confirm {
    font-size: 14px !important;
    transition: background-color 0.5s ease-in-out;
}

.vue-dialog-button.cancel:focus,
.vue-dialog-button.confirm:focus {
    outline: none;
}

.vue-dialog-button.confirm {
    background-color: #7bb026;
    color: #fff;
}

.vue-dialog-button.confirm:hover {
    background-color: #8eca2e;
}

.vue-dialog-button.cancel:hover {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>